import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock } from 'lucide-react';
const events = [{
  title: 'Jarní školení',
  date: '28. února 2026',
  description: 'Každoroční setkání pilotů a lidí napojených na dění kolem letiště Hořovice.',
  type: 'Vzdělávání'
}, {
  title: 'Seskoky padákem',
  date: '21. června 2026',
  description: '0900 až 1700 CET Seskoky padákem včetně tandemových seskoků. Možnost objednání zážitkových poukazů.',
  type: 'Parašutismus'
}, {
  title: 'Ukázka letadel pro nemocné děti',
  date: '1. srpna 2026',
  description: 'Dětský den s ukázkou letecké techniky na letišti Hořovice pro děti z místní nemocnice.',
  type: 'Zábava'
}];
export function Events() {
  return <section id="events" className="py-24 bg-[#0f1d35] relative overflow-hidden" data-id="element-53">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#0a1628] to-transparent opacity-50 pointer-events-none" data-id="element-54" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4" data-id="element-56">
          <div data-id="element-57">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-58">
              Nadcházející akce
            </h2>
            <p className="text-white/60" data-id="element-59">
              Přijďte na letiště na tyto speciální akce.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-60">
          {events.map((event, index) => <motion.div key={event.title} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#0a1628] border-l-4 border-[#38bdf8] p-6 rounded-r-xl hover:translate-x-2 transition-transform duration-300" data-id="element-61">
              <div className="flex items-center justify-between mb-4" data-id="element-62">
                <span className="bg-[#38bdf8]/10 text-[#38bdf8] text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-63">
                  {event.type}
                </span>
                <div className="flex items-center text-white/40 text-sm" data-id="element-64">
                  <Clock size={14} className="mr-1" data-id="element-65" />
                  <span data-id="element-66">Připravujeme</span>
                </div>
              </div>

              <h3 className="text-xl font-bold text-white mb-2" data-id="element-67">
                {event.title}
              </h3>
              <div className="flex items-center text-white/70 text-sm mb-4 font-mono" data-id="element-68">
                <Calendar size={14} className="mr-2 text-[#38bdf8]" data-id="element-69" />
                {event.date}
              </div>

              <p className="text-white/50 text-sm leading-relaxed" data-id="element-70">
                {event.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}